import React from 'react';
import {
  AllieChip,
  AllieChipColorProps,
  AllieItem,
  AlliePriorityFlag,
  AllieText,
} from '../../../components';
import type { AlliePriorityFlagOptions } from '../../../components/Flag/Flag.types';
import { StyledPriorityContainer } from './Priority.styles';

const mapPriorityToColor: Record<AlliePriorityFlagOptions, AllieChipColorProps> = {
  1: { allieColor: 'error-main', backgroundColor: 'error-10' },
  2: { allieColor: 'warning-60', backgroundColor: 'warning-10' },
  3: { allieColor: 'success-70', backgroundColor: 'success-20' },
};

export const AlliePriority: React.FC<{ value: AlliePriorityFlagOptions }> = ({ value }) => (
  <StyledPriorityContainer>
    <AllieItem>
      <AllieChip
        color={mapPriorityToColor[value]}
        style={{ columnGap: '5px', borderRadius: '8px', paddingInline: '8px' }}
      >
        <AlliePriorityFlag slot="start" priority={value} />
        <AllieText type="field1" color={mapPriorityToColor[value].allieColor}>
          {value}
        </AllieText>
      </AllieChip>
    </AllieItem>
  </StyledPriorityContainer>
);
